var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4545 10.9091C20.4545 13.9216 18.0125 16.3636 15 16.3636C11.9875 16.3636 9.54545 13.9216 9.54545 10.9091C9.54545 7.89663 11.9875 5.45455 15 5.45455C18.0125 5.45455 20.4545 7.89663 20.4545 10.9091ZM17.7273 10.9091C17.7273 12.4153 16.5062 13.6364 15 13.6364C13.4938 13.6364 12.2727 12.4153 12.2727 10.9091C12.2727 9.40286 13.4938 8.18182 15 8.18182C16.5062 8.18182 17.7273 9.40286 17.7273 10.9091Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0ZM2.72727 15C2.72727 17.8503 3.69893 20.4736 5.32907 22.5569C7.57152 19.6212 11.1085 17.7273 15.0879 17.7273C19.0157 17.7273 22.5125 19.5724 24.7589 22.4431C26.336 20.3785 27.2727 17.7987 27.2727 15C27.2727 8.22196 21.778 2.72727 15 2.72727C8.22196 2.72727 2.72727 8.22196 2.72727 15ZM15 27.2727C12.0679 27.2727 9.37589 26.2445 7.26501 24.5289C8.99116 22.0653 11.8514 20.4545 15.0879 20.4545C18.2842 20.4545 21.1136 22.0256 22.8461 24.4375C20.7189 26.2079 17.9838 27.2727 15 27.2727Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b0577bd7.svg";
export { ForwardRef as ReactComponent };